import React from "react";
import { css, useTheme } from "@emotion/react";
import { ReactComponent as CloseIcon } from "../../../img/butter_svgs/Close.svg";
import { getTokenIcon } from "../../../utils/tokenIconUtils";
import { Button } from "../../general/Button/Button";
import { Text } from "../../general/Text";
import { Token } from "../../../store/global/TokenEnum";
import { withIsVisible } from "../../../utils/reactUtils";
import styled from "@emotion/styled";
import { useTokenListByChain } from "hooks/useTokenListByChain";

export interface SelectedTokenButtonProps {
  symbol: Token;
  removeToken: () => void;
  onClick: () => void;
}
const SelectedTokensButton: React.FC<SelectedTokenButtonProps> = ({
  symbol,
  removeToken,
  onClick,
}) => {
  const theme = useTheme();
  const tokenList = useTokenListByChain();

  return (
    <Button
      buttonType="quaternary"
      text={symbol}
      buttonCss={css`
        padding: 6px;
        border-radius: 16px;
        cursor: default;
      `}
      onClick={onClick}
    >
      <img
        width={20}
        src={getTokenIcon(symbol, tokenList)}
        alt={"Selected Token Icon"}
        style={{ borderRadius: "50%" }}
      />
      <Text textStyle="Button" size="Extra Large" color={theme.button.quaternary.text.default}>
        {symbol}{" "}
      </Text>
      <CloseButton onClick={removeToken}>
        <CloseIcon width={20} />
      </CloseButton>
    </Button>
  );
};

export default withIsVisible(SelectedTokensButton);

// Sub-components

const CloseButton = styled.div(({ theme }) => {
  return {
    position: "relative",
    zIndex: 1,
    background: "none",
    border: "none",
    borderRadius: "50%",
    padding: 0,
    color: theme.theme[1200],
    top: 2,
    right: 1,
  };
});
